import React from 'react';
import { UIBasic, IPropsBasic } from 'kts-scaffold-framework/modules';
import { connect } from 'kts-platform-frame/redux';
import ReduxState, { } from 'kts-platform-frame/redux/ReduxState';
import ModulesState from './Modules.State';
import { history } from 'kts-platform-frame/routes';
import ModulesAction from './Modules.Action';
import { Form, Table, Tag, Button, Card, Col, Row, message, Input, DatePicker, Popconfirm } from 'antd';
import moment from 'moment';
import { outputApi } from '../../../api'; 
import { Field } from 'kts-scaffold-framework/utils/doc';
const FormItem = Form.Item;
const EditableCell = ({ editable, value, column, onChange }) => {
    if (column === 'amountWithoutTax' || column === 'tax') {
        return (
            <div>
                {editable
                    ? <Input value={value} type='number' onChange={e => onChange(e.target.value)} />
                    : value
                }
            </div>
        );
    } else {
        return (
            <div>
                {editable
                    ? <Input value={value} onChange={e => onChange(e.target.value)} />
                    : value
                }
            </div>
        );
    }
};
const EditableDateCell = ({ editable, value, onChange }) => {

    return (
        <div>
            {editable
                ? <DatePicker value={value} onChange={e => onChange(e)} allowClear={false} />
                : value ? moment(value).format('YYYY-MM-DD') : ''
            }
        </div>);
};
interface IReduxStatePart {
    companyId?: string;
}

/** Props接口 */
interface IProps extends IReduxStatePart, IPropsBasic {

}


/** 绑定全局数据到props */
@ModulesAction.uiconnect
@connect((state: ReduxState): IReduxStatePart => ({
    companyId: state.user.currentcompanyId,
}))
export default class UICreate extends UIBasic<any, ModulesState, any> {
    /**
     * 
     * @param {*开票记录} props 
     */
    public spanCss = { cursor: "pointer" };
    public columns = [
        {
            title: "序号",
            dataIndex: "key",
            width: 55,
            render: (text, _, index) => {
                return (
                    <div className="text-center">{((index + 1) + (this.state.pageNum - 1) * this.state.pageSize)}</div>
                );
            }
        },
        {
            title: <span>发票代码<span style={{ 'color': 'red' }}>*</span></span>,
            dataIndex: "invoiceCode",
            width: 100,
            render: (text, record) => this.renderColumns(text, record, 'invoiceCode'),
        },
        {
            title: <span>发票号码<span style={{ 'color': 'red' }}>*</span></span>,
            dataIndex: "invoiceNumber",
            width: 100,
            render: (text, record) => this.renderColumns(text, record, 'invoiceNumber'),
        },
        {
            title: <span>开票日期<span style={{ 'color': 'red' }}>*</span></span>,
            dataIndex: "invoiceDate",
            width: 100,
            render: (text, record) => this.renderColumns(text, record, 'invoiceDate'),
        },
        {
            title: "金额",
            dataIndex: "amountWithoutTax",
            width: 80,
            // render: (text, record) => this.renderColumns(text, record, 'amount'),
            render: text => Field.formatMoney(text, 2)
        },
        {
            title: "税额",
            dataIndex: "amountTax",
            width: 80,
            // render: (text, record) => this.renderColumns(text, record, 'tax'),
            render: text => Field.formatMoney(text, 2)
        },
        {
            title: "价税合计",
            dataIndex: 'amount',
            width: 80,
            render: (text) => {
                return  Field.formatMoney(text && parseFloat(text).toFixed(2));
            },
        },
        {
            title: "备注",
            dataIndex: "remark",
            width: 120,
            render: (text, record) => {
                let substring = text;
                return this.renderColumns(substring, record, 'remark');
            },
        },
    ];
    private cacheData = [];
    constructor(props: any) {
        super(props, ModulesAction);
        this.state = {
            data: null,
            pageSize: 10,
            pageNum: 1,
            passState: this.props.location.state,
            companyId: null,
            countData: null,
            editable: false,
            canAdd: true,
            count: 0,
            dataSource: [],
            loading: false
        };

    }
    //编辑模式
    edit = (key) => {
        const newData = [...this.state.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
            target.editable = true;
            this.setState({ dataSource: newData });
        }
    }
    onReload = () => {
        outputApi.outputDetail(this, { noticeId: this.state.passState.noticeId }).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.setState({
                        passState: res
                    });
                }
            }
        });
    }
    //保存修改或者新增
    save = record => {
        //新增记录
        if (record.add) {
            if (record.invoiceCode === '' || record.invoiceNumber === '' || record.creatDate === '') {
                message.warn('缺少必填项');
            } else {
                record.invoiceId = this.state.passState.noticeId;
                this.sendList(record);
            }
        } else {
            //保存修改

            outputApi.outputCreateRecord(this, record).then((response: any) => {
                const err = response.err;
                const data = response.res;
                if (err) {
                    message.error(err.status.description);
                    return null;
                } else {
                    if (data) {
                        const newData = [...this.state.dataSource];
                        const target = newData.filter(item => record.key === item.key)[0];
                        if (target) {
                            delete target.editable;
                            this.setState({ dataSource: newData });
                            this.cacheData = newData.map(item => ({ ...item }));
                        }
                    }
                }
            });
        }
    }
    //取消编辑
    cancel = (record: any) => {
        //取消添加
        if (record.add) {
            const newData = [...this.state.dataSource];
            const target = newData.filter(item => record.key !== item.key);
            this.setState({
                dataSource: target,
                canAdd: true
            });
        } else {
            //取消编辑
            const newData = [...this.state.dataSource];
            const target = newData.filter(item => record.key === item.key)[0];
            if (target) {
                Object.assign(target, this.cacheData.filter(item => record.key === item.key)[0]);
                delete target.editable;
                this.setState({ dataSource: newData });
            }
        }
    }
    //删除
    onDelete = record => {
        let { invoiceId } = record;
        const { passState } = this.state;
        let data = {
            noticeId: passState.noticeId,
            invoiceId: invoiceId
        };
        outputApi.outputDeleteRecord(this, data).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    this.getList();
                }
            }
        });

    }
    renderColumns = (text, record, column) => {
        if (column === 'invoiceDate') {
            return (
                <EditableDateCell
                    editable={record.editable}
                    value={text}
                    onChange={value => this.handleChange(value, record.key, column)}
                />
            );
        } else {
            return (
                <EditableCell
                    editable={record.editable}
                    value={text}
                    column={column}
                    onChange={value => this.handleChange(value, record.key, column)}
                />
            );
        }
    }
    componentDidMount() {
        this.getList();
        this.onReload();
    }
    getList = () => {
        let data = this.state.passState.noticeId;

        outputApi.outputMatchRecord(this, { noticeId: data }).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    if (res.length > 0) {
                        this.setState({
                            dataSource: res,
                            count: 0
                        });
                        //this.getInvoiceoutputs(res);
                    } else {

                    }
                }
            }
        });
    }
    onFresh = () => {
        this.setState({
            canAdd: true
        });
        this.getList();
    }
    getInvoiceoutputs = arr => {
        let list = [];
        for (let i = 0; i < arr.length; i++) {
            list.push(arr[i].invoiceBizId);
        }
        outputApi.outputStaticsRecord(this, list).then((response: any) => {
            const err = response.err;
            const data = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (data) {
                    for (let i = 0; i < data.length; i++) {
                        data[i].invoiceDate = moment(data[i].invoiceDate);
                        data[i].key = i.toString();
                    }
                    this.setState({
                        dataSource: data,
                        count: data.length
                    });
                    this.cacheData = data.map(item => ({ ...item }));
                }
            }
        });

    }
    //修改内容
    handleChange = (value, key, column) => {
        const newData = [...this.state.dataSource];
        const target = newData.filter(item => key === item.key)[0];
        if (target) {
            target[column] = value;
            this.setState({ dataSource: newData });
        }
    }
    //新增项
    handleAdd = () => {
        const { count, dataSource, canAdd } = this.state;
        if (!canAdd) {
            message.warn('一次只能增加一条');
            return;
        }
        let invoiceCode = (dataSource[dataSource.length - 1] && dataSource[dataSource.length - 1].invoiceCode) || '';
        const newData = {
            key: count + 1,
            invoiceCode: invoiceCode,
            invoiceNumber: '',
            invoiceDate: moment(),
            amountWithoutTax: '',
            tax: '',
            amount: '',
            remark: '',
            editable: true,
            add: true,
        };
        this.setState({
            dataSource: [...dataSource, newData],
            count: count + 1,
            canAdd: false
        });
    }
    sendList = record => {
        let data = JSON.parse(JSON.stringify(record));
        let { companyId } = this.state;
        data.invoiceDate = moment(data.invoiceDate).format('YYYY-MM-DD');
        data.companyId = companyId;

        outputApi.outputCreateRecord(this, data).then((response: any) => {
            const err = response.err;
            const res = response.res;
            if (err) {
                message.error(err.status.description);
                return null;
            } else {
                if (res) {
                    message.success('操作成功');
                    this.onFresh();
                    this.setState({
                        canAdd: true
                    });
                }
            }
        });

    }
    render() {
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 16 },
        };
        let { dataSource } = this.state;
        const data = this.state.passState;
        let _datasource = dataSource && dataSource.map((item, index) => {
            return {
                ...item,
                index
            };
        });
        let amount = 0, tax = 0;
        for (let i = 0; i < _datasource.length; i++) {
            amount += parseFloat(_datasource[i].amountWithoutTax || 0);
            tax += parseFloat(_datasource[i].amountTax || 0);
        }
        return (
            <div>

                <Card
                    title='开票记录'
                    extra={
                        <div>
                            <Button type='default' icon='sync' onClick={this.onFresh}>刷新</Button>
                            <Button type="default" className="ml-10" onClick={() => history.goBack()}>返回</Button>
                        </div>
                    }
                >
                    <Row>
                        <Col span={18}>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="单号"
                                >
                                    <span className="ant-form-text">{data.noticeId}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="时间"
                                >
                                    <span className="ant-form-text">{Field.formatDate(data.createTime)}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="结算时间"
                                >
                                    <span className="ant-form-text">{Field.formatDate(data.settlEndTime)}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="购方名称"
                                >
                                    <span >{data.buyerName}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="总税额"
                                >
                                    <span className="ant-form-text">{Field.formatMoney(data.amountTax, 2)}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="结算部门"
                                >
                                    <span className="ant-form-text">{data.supplierDepartment}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="总金额"
                                >
                                    <span className="ant-form-text">{Field.formatMoney(data.amountWithoutTax, 2)}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="价税合计"
                                >
                                    <span className="ant-form-text">{Field.formatMoney(data.amountSum, 2)}</span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="状态"
                                >
                                    <span className="ant-form-text">
                                        {data.makeInvoiceState === 1 && <Tag color='green'>已开票</Tag>}
                                        {data.noticeBillState === 'CREATED' && <Tag color='green'>已送达</Tag>}
                                        {data.noticeBillState === 'SENDED' && <Tag color='green'>已发送</Tag>}
                                        {data.noticeBillState === 'ACCEPTED' && <Tag color='green'>接受</Tag>}
                                        {data.noticeBillState === 'REFUSED' && <Tag color='red'>拒绝</Tag>}
                                        {data.noticeBillState === 'INVALID' && <Tag color='yellow'>作废</Tag>}
                                    </span>
                                </FormItem>
                            </Col>
                            <Col span={8}>
                                <FormItem
                                    {...formItemLayout}
                                    label="销方名称"
                                >
                                    <span >{data.supplierName}</span>
                                </FormItem>
                            </Col>
                        </Col>
                        <Col span={6}>
                            <FormItem
                                {...formItemLayout}
                                label="备注"
                            >
                                <span className="ant-form-text">{data.remark}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Button type="primary" className="hide" onClick={this.handleAdd}>新增记录</Button>
                    <Table
                        columns={this.columns}
                        dataSource={_datasource}
                        pagination={false}
                        rowKey="index"
                    />
                    <div className="pull-right" style={{ 'marginTop': '16px' }}>
                        <span style={{ 'marginRight': '10px' }}>金额 </span><span className="bold_number">  ¥{Field.formatMoney(amount, 2)}</span>
                        <span style={{ 'padding': '0 15px' }}>|</span><span style={{ 'marginRight': '10px' }}>税额 </span><span className="bold_number"> ¥{Field.formatMoney(tax, 2)}</span>
                        <span style={{ 'padding': '0 15px' }}>|</span><span style={{ 'marginRight': '10px' }}>价税合计 </span><span className="bold_number"> ¥{Field.formatMoney((amount + tax), 2)}</span>
                    </div>
                </Card>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/display/apps/OutputSettlement/UI.Create.tsx